// Client-side URL parser for imported videos.
// Returns { type, id|url, ... } or null if unsupported.
// Mirrors backend _resolve_video_url in server.py (kept in sync by tests).

export function detectVideoSource(raw) {
  const u = (raw || '').trim();
  if (!u) return null;

  let m;
  m = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([\w-]{11})/);
  if (m) return { type: 'youtube', id: m[1], thumb: `https://i.ytimg.com/vi/${m[1]}/hqdefault.jpg` };

  m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return { type: 'vimeo', id: m[1] };

  m = u.match(/drive\.google\.com\/(?:file\/d\/|open\?id=|uc\?(?:export=download&)?id=)([\w-]{10,})/);
  if (m) return { type: 'gdrive', id: m[1], thumb: `https://drive.google.com/thumbnail?id=${m[1]}&sz=w1280` };

  m = u.match(/(https?:\/\/(?:www\.)?dropbox\.com\/s(?:cl\/fi|)\/[^\s?]+)/);
  if (m) {
    let direct = m[1].replace(/[?&]dl=\d/g, '');
    direct += (direct.includes('?') ? '&' : '?') + 'raw=1';
    return { type: 'direct', url: direct };
  }

  m = u.match(/dailymotion\.com\/(?:video|embed\/video)\/([\w-]+)/);
  if (m) return { type: 'dailymotion', id: m[1] };

  m = u.match(/twitch\.tv\/videos\/(\d+)/);
  if (m) return { type: 'twitch', id: m[1], kind: 'video' };
  m = u.match(/clips\.twitch\.tv\/([\w-]+)/);
  if (m) return { type: 'twitch', id: m[1], kind: 'clip' };

  if (/facebook\.com|fb\.watch/.test(u)) return { type: 'facebook', url: u };

  if (/\.m3u8($|\?)/i.test(u)) return { type: 'hls', url: u };
  if (/\.mpd($|\?)/i.test(u)) return { type: 'dash', url: u };

  if (/\.(mp4|webm|mov|m4v|ogg|ogv)(\?|$)/i.test(u) && u.startsWith('http')) return { type: 'direct', url: u };

  return null;
}

export const SOURCE_LABELS = {
  youtube: 'YouTube', vimeo: 'Vimeo', gdrive: 'Google Drive', dropbox: 'Dropbox',
  dailymotion: 'Dailymotion', twitch: 'Twitch', facebook: 'Facebook',
  direct: 'Direct (MP4/WEBM)', hls: 'HLS stream', dash: 'DASH stream', file: 'Uploaded file',
};

// Which source types can be downloaded at all (technically possible + allowed)?
export const DOWNLOADABLE_TYPES = new Set(['file', 'direct', 'gdrive']);
